
import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import { namespace } from "vuex-class";

const app = namespace("app");
@Component({})
export default class PurchaseConfirm extends Vue {
  @app.State btnLoading;
  @app.Mutation btnStartLoading;
  @app.Mutation btnStopLoading;
  @Prop({ default: false, type: Boolean })
  visible: boolean;
  @Prop({ default: () => {}, type: Object })
  purchaseData: any;
  handleComplete() {
    this.$refs.inWareTable as any;
    this.$emit("confirm", this.selectionRows);
  }
  handleColse() {
    this.$emit("update:visible", false);
  }
  get needCheck(): boolean {
    // 需要勾选关联服务单的其他采购单
    return !!this.purchaseData?.orderNo;
  }

  get purchaseList() {
    return (this.purchaseData?.orderRelevanceUncompletedPurchaseNoList || []).map(purchaseNo => ({
      purchaseNo: purchaseNo,
      current: purchaseNo === this.purchaseData.purchaseNo
    }));
  }
  partsHasZero: boolean = false;
  @Watch("visible")
  visibleChange(visible) {
    if (visible) {
      if (
        this.purchaseData.detailList.some(parts => {
          return Number(parts.costPrice) === 0;
        })
      ) {
        {
          this.partsHasZero = true;
        }
      }
      this.$nextTick(() => {
        const tableRef = this.$refs.inWareTable as any;
        if (!tableRef) return;
        this.purchaseList.forEach(item => {
          tableRef.toggleRowSelection(item, true);
        });
      });
    }
  }
  checkSelectable(row) {
    return !row.current;
  }
  selectionRows = [];
  handleSelctionChange(rows) {
    this.selectionRows = rows;
  }
}
